import React, {ReactElement} from 'react'
import {useTranslation} from 'react-i18next'
import {FormProvider, useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import * as yup from 'yup'
import {SoiPeeringWan} from '../../app/types'
import ErrorAlert from '../../common/components/ErrorAlert'
import FormContainer from '../../common/form/FormContainer'
import FormRow from '../../common/form/FormRow'
import FormFieldBox from '../../common/form/FormFieldBox'
import TextInput from '../../common/form/TextInput'
import {useFormSubmission} from '../../common/servercall/useFormSubmission'
import FormGroup from '../../common/form/FormGroup'

const schema = yup
    .object()
    .shape({
        pbxWanIp: yup.string().matches(/^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/, {
            message: 'invalid-wan-ip',
            excludeEmptyString: true,
        }).nullable(),
        pbxWanPort: yup.number().typeError('invalid-wan-port').min(1025, 'invalid-wan-port').max(65535, 'invalid-wan-port').nullable(),
    }).required()

type Props = {
    form: SoiPeeringWan
    onSubmit: (formData: SoiPeeringWan) => void
    buildFormButtons: (isSubmitting: boolean) => ReactElement
}

const SoiPeeringWanFormScreen = ({form, onSubmit, buildFormButtons }: Props) => {
    const { t } = useTranslation()

    const { control, handleSubmit, setError, clearErrors } = useForm<SoiPeeringWan>({
        resolver: yupResolver(schema),
        values: form,
    })

    const { submit, isSubmitting, serverError, onError } = useFormSubmission<SoiPeeringWan>(onSubmit, setError)

    return (
        // @ts-ignore
        <FormProvider clearErrors={clearErrors}>
            <ErrorAlert errorKey={typeof serverError === 'string' ? serverError : undefined} showAlert={!!serverError} />
            <FormContainer onSubmit={handleSubmit(submit, onError)}>
                <FormGroup fullWidth={true}>
                        <FormRow>
                            <FormFieldBox >
                                <TextInput
                                    readonly={false}
                                    label={t('trunking-sites.pbx-wan-ip')}
                                    name={'pbxWanIp'}
                                    control={control}
                                    required={true}
                                />
                            </FormFieldBox>
                            <FormFieldBox >
                                <TextInput
                                    readonly={false}
                                    label={t('trunking-sites.pbx-wan-port')}
                                    name={'pbxWanPort'}
                                    control={control}
                                    required={true}
                                />
                            </FormFieldBox>
                        </FormRow>
                </FormGroup>
                {buildFormButtons(isSubmitting)}
            </FormContainer>
        </FormProvider>
    )
}

export default SoiPeeringWanFormScreen
